import _ from "lodash";
import { useCallback, useState } from "react";
import { cancelRequest } from "ClassRoom/components/AddAssignment/AiQuestionAssistant/modules/AiQuestionAssistantModule";
import useAiQuestionSaveToServer from "./useAiQuestionSaveToServer";

// * Safely triggers the active AI request cancellation.
const triggerCancelRequest = () => {
  const onCancelRequest = _.isFunction(cancelRequest) ? cancelRequest : _.noop;
  onCancelRequest();
};

/**
 *
 * @param {*} props
 * @returns Ai Question Streaming and Saving to server
 */
export const useAiQuestionGenerator = props => {
  const { resetAIHistory, onGenerateComplete, getAssessmentQuestions } = props;
  const [stopTriggered, setStopTriggered] = useState(false);

  // * Callback to handle completion of AI question generation, including cleanup and refetching questions.
  const onGenerationComplete = useCallback(() => {
    triggerCancelRequest();
    resetAIHistory();
    getAssessmentQuestions?.refetch?.();
    onGenerateComplete?.({ closeAiPanel: true });
  }, [resetAIHistory, onGenerateComplete, getAssessmentQuestions]);

  // * Manual trigger to stop AI question generation, which cancels the request and sets the stop flag.
  const manualStopGeneration = useCallback(() => {
    triggerCancelRequest();
    setStopTriggered(true);
  }, []);

  const payload = { ...props, stopTriggered, onGenerationComplete };
  useAiQuestionSaveToServer(payload);

  return { stopTriggered, stopGeneration: manualStopGeneration };
};
